module.exports = __webpack_public_path__ + "img/cloud-rain-sun-2.30d39625.svg";